import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import GiftCards from "./pages/GiftCards";
import GiftCardAdmin from "./pages/GiftCardAdmin";
import AdminLogin from "./pages/AdminLogin";
import Portfolio from "./pages/Portfolio";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gift-cards" element={<GiftCards />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/gift-cards" 
            element={
              <ProtectedRoute>
                <GiftCardAdmin />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
